import { Form, Table, Modal, Label, Button } from "semantic-ui-react";
import SemanticDatepicker from "react-semantic-ui-datepickers";
import { useEffect, useState, useContext } from "react";
import MDL_PROGRESS from "../../../components/cmp-progress/cmp-progress";
import { ActivityLogs, ActivityStats } from "../../../constants";
import MDL_VIEW_DETAILS from "./mdl-view-description/mdl-view-description";
import LineChart from "./line_chart/line-chart";
import AppPagination from "../../../components/cmp-pagination/Pagination";
import { AppContext } from "../../../Context/AppContext";
import "react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css";
import "./PortalLogs.css";

function PortalLogs() {
  /* VARIABLE DECLARATIONS
	=================================================================================*/
  const { userInfo, appVersion, isAppVersionOutdated } = useContext(AppContext);
  const [user] = userInfo;
  const [var_app_version] = appVersion;
  const [, set_is_app_version_outdated] = isAppVersionOutdated;
  const [dateRange, setDateRange] = useState([]);
  const [rolefilter, setRoleFilter] = useState("admin");
  const [chartTimeRange, setChartTimeRange] = useState("3");
  const [chartDetails, setChartDetails] = useState([]);
  const [locationCode, setLocationCode] = useState("");
  const [var_mdl_progress, set_mdl_progress] = useState(false);
  const [portalLogs, setportalLogs] = useState([]);
  const [var_mdl_view_detail_open, set_mdl_view_detail_open] = useState(false);
  const [var_detail_data, set_detail_data] = useState("");
  const [var_detail_title, set_detail_title] = useState("");
  const [var_detail_log_time, set_detail_log_time] = useState(null);
  const [firstRender, setFirstRender] = useState(true);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [query_param, setQueryParams] = useState("");
  /* EVENT LISTENERS
	=================================================================================*/
  useEffect(() => {
    getportalLogs(page, limit);
  }, [page, limit]);

  useEffect(() => {
    if (!firstRender && page === 1) {
      getportalLogs(1, limit);
    }
    setPage(1);
    setFirstRender(false);
  }, [rolefilter, dateRange]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (!firstRender && page === 1) {
        getportalLogs(1, limit);
      }
      setPage(1);
    }, 500);
    setFirstRender(false);

    return () => clearTimeout(delayDebounceFn);
  }, [locationCode]);

  useEffect(() => {
    getChartDetails();
  }, []);

  /* Async functions
	---------------------------------------------------------------------------------*/
  async function getChartDetails() {
    set_mdl_progress(true);
    const requestHeaders = {
      headers: {
        entityid: user.uuid,
        appversion: var_app_version,
      },
    };
    await fetch(ActivityStats, requestHeaders)
      .then((response) => response.json())
      .then((res) => {
        if (res.code === 200) {
          setChartDetails(res.data);
        } else {
          if (res?.version && res?.version !== var_app_version) {
            set_is_app_version_outdated(true);
          }
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setChartDetails([]);
      });
    set_mdl_progress(false);
  }

  async function getportalLogs(page_no, limit_range) {
    const params = new URLSearchParams();
    if (rolefilter) params.append("field", rolefilter);
    if (dateRange?.[0]) params.append("startDate", dateRange[0]);
    if (dateRange?.[1]) params.append("endDate", dateRange[1]);
    if (locationCode) params.append("locationCode", locationCode);
    params.append("page", page_no ? page_no : page);
    params.append("limit", limit_range ? limit_range : limit);
    const query_params = params.toString() ? `?${params.toString()}` : "";
    setQueryParams(query_params);
    const requestHeaders = {
      headers: {
        entityid: user.uuid,
        appversion: var_app_version,
      },
    };
    set_mdl_progress(true);
    await fetch(ActivityLogs + query_params, requestHeaders)
      .then((response) => response.json())
      .then((res) => {
        var logs = [];
        if (res.code === 200) {
          logs = res?.data;
        } else {
          if (res?.version && res?.version !== var_app_version) {
            set_is_app_version_outdated(true);
          }
          logs = [];
        }
        if ((page && page > 1) || (page_no && page_no > 1))
          logs = [...portalLogs, ...logs];
        setportalLogs(logs);
      })
      .catch((error) => {
        console.error("Error:", error);
        setportalLogs([]);
      });
    set_mdl_progress(false);
  }

  async function downloadInvoiceReport() {
    const query_params = query_param;
    const url = `${ActivityLogs}${query_params}&export=true&entityid=${user.uuid}`;
    try {
      window.open(url, "_blank");
    } catch (error) {
      console.error("Error:", error);
    }
  }

  /* EVENT FUNCTIONS
	=================================================================================*/
  const renderTableItems = (val, index) => (
    <Table.Row key={index}>
      <Table.Cell>{formatVal(val?.performedBy)}</Table.Cell>
      <Table.Cell width={4}>{formatVal(val?.activity)}</Table.Cell>
      <Table.Cell>{formatVal(val?.targetEntity)}</Table.Cell>
      <Table.Cell>
        {new Date(val?.userActivityLogTime).toLocaleString("en-US", {
          year: "numeric",
          month: "short",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })}
      </Table.Cell>
      <Table.Cell>{formatVal(val?.fieldName)}</Table.Cell>
      <Table.Cell>{val?.locationCode}</Table.Cell>
      <Table.Cell width={1} className="td-action" collapsing textAlign="right">
        <Label
          color="blue"
          onClick={() =>
            viewDescription(val?.description, val?.userActivityLogTime)
          }
        >
          View
        </Label>
      </Table.Cell>
    </Table.Row>
  );

  const viewDescription = (description, logTime) => {
    HandleMdlDetails(description, "Description", logTime);
  };

  function HandleMdlDetails(data, title, logTime) {
    Array.isArray(data) ? set_detail_data(data) : set_detail_data([data]);
    set_detail_title(title);
    set_detail_log_time(logTime || null);
    set_mdl_view_detail_open(true);
  }

  function convertToDateStrings(dateArray) {
    return dateArray.map((dateStr) => {
      const date = new Date(dateStr);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    });
  }

  const handleDateChange = (event, data) => {
    const { value } = data;
    if (!value) {
      setDateRange([]);
    }
    if (value && value.length === 2) {
      const formattedDates = convertToDateStrings(value);
      setDateRange(formattedDates);
    }
  };

  const handleFilterChange = (e, data) => {
    setRoleFilter(data.value);
  };

  const handleTimeRangeChange = (e, data) => {
    setChartTimeRange(data.value);
  };

  const handleLocationChange = (e, data) => {
    setLocationCode(String(data.value));
  };

  const formatVal = (key) => {
    return key
      ?.replace(/_/g, " ")
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };
  /* RENDER APP
	=================================================================================*/
  return (
    <>
      {" "}
      <div className="app-content">
        <div className="app-building-container">
          <div className="charts-container">
            <div className="graph-filter">
              <Form.Select
                className="time_span_filter"
                id="time_span_filter"
                name="time_span_filter"
                placeholder="Time Range"
                required
                onChange={handleTimeRangeChange}
                value={chartTimeRange}
                style={{ marginRight: "8px" }}
                options={[
                  { key: 0, text: "3 Months", value: "3" },
                  { key: 1, text: "6 Months ", value: "6" },
                  { key: 2, text: "9 Months ", value: "9" },
                  { key: 3, text: "12 Months ", value: "12" },
                ]}
              />
            </div>
            <div className="line-chart">
              <LineChart
                chartTimeRange={chartTimeRange}
                chartDetails={chartDetails}
              />
            </div>
          </div>
          <div className="app-card">
            <div className="app-card-header building-managment-header-card">
              <div className="app-card-title" style={{ marginRight: "8px" }}>
                Logs ({portalLogs.length})
              </div>
              <div
                className="app-content-action"
                style={{ marginBottom: "0px" }}
              >
                <div className="logs-app-content-action-right">
                  <div className="dropdown_filter">
                    <Form.Select
                      className="role_filter"
                      id="role_filter"
                      name="role_filter"
                      placeholder="Field"
                      required
                      onChange={handleFilterChange}
                      value={rolefilter}
                      options={[
                        { key: 0, text: "Admin ", value: "admin" },
                        { key: 1, text: "Customer ", value: "customer" },
                        { key: 2, text: "Scheduler ", value: "scheduler" },
                        { key: 3, text: "System ", value: "system" },
                      ]}
                    />
                  </div>

                  <div className="end_date_picker">
                    <SemanticDatepicker
                      className="date_picker"
                      name={"end_date_picker"}
                      onChange={(e, data) => handleDateChange(e, data, "end")}
                      placeholder="Select Date Range"
                      type="range"
                      showToday={false}
                      maxDate={new Date()}
                      minDate={new Date().setMonth(new Date().getMonth() - 3)}
                    />
                  </div>

                  <Form.Input
                    className="location_field"
                    name="location_field"
                    placeholder="Location Code"
                    icon="location arrow"
                    type="number"
                    min="0"
                    value={locationCode}
                    onChange={handleLocationChange}
                  ></Form.Input>
                  {
                    <Button
                      color="blue"
                      disabled={portalLogs.length === 0}
                      onClick={() => {
                        downloadInvoiceReport();
                      }}
                      content="Download"
                    >
                      <img src="/history.png" alt="icon" />
                      Export
                    </Button>
                  }
                </div>
              </div>
            </div>

            {/* Main table section */}
            <div className="app-table-wrapper">
              <Table unstackable>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Performed By</Table.HeaderCell>
                    <Table.HeaderCell>Activity Performed</Table.HeaderCell>
                    <Table.HeaderCell>Target Entity</Table.HeaderCell>
                    <Table.HeaderCell>Date & Time</Table.HeaderCell>
                    <Table.HeaderCell>Field</Table.HeaderCell>
                    <Table.HeaderCell>LocationCode</Table.HeaderCell>
                    <Table.HeaderCell>Actions</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {portalLogs.length !== 0 &&
                    portalLogs.map((val, index) =>
                      renderTableItems(val, index),
                    )}
                </Table.Body>
              </Table>
              {!var_mdl_progress && portalLogs.length === 0 && (
                <div className="nodata-placeholder">
                  There is no Logs to display
                </div>
              )}
            </div>
          </div>
          <AppPagination
            limit={limit}
            setLimit={setLimit}
            page={page}
            setPage={setPage}
            rowsTotal={portalLogs.length}
          />
        </div>
      </div>
      {/***** MODAL: PROGRESS **************************************************************************/}
      <Modal
        id="mdl-progress"
        dimmer={"inverted"}
        open={var_mdl_progress}
        closeOnDimmerClick={false}
        closeOnEscape={false}
        onClose={() => {}}
      >
        <MDL_PROGRESS
          set_mdl_open={set_mdl_progress}
          var_modaltitle="Please wait"
          var_message={"Stay on this page until this process finish."}
        ></MDL_PROGRESS>
      </Modal>
      {/***** MODAL: view Description **************************************************************************/}
      <Modal
        id="mdl-view-detail"
        dimmer={"inverted"}
        size="large"
        open={var_mdl_view_detail_open}
        onClose={() => {
          set_mdl_view_detail_open(false);
        }}
      >
        <MDL_VIEW_DETAILS
          set_mdl_open={set_mdl_view_detail_open}
          data={var_detail_data}
          title={var_detail_title}
          logTime={var_detail_log_time}
        />
      </Modal>
      {/***** MODAL: view Description **************************************************************************/}
    </>
  );
}

export default PortalLogs;
